<template>
  <v-container text-center v-if="isConfigLoaded">
    <v-card class="mx-auto" elevation="0">
      <br />
      <br />
      <div>
        <template v-if="!isShowExistingTicket">
          <h2
            v-if="isShowCheckinHeader && isShowAppointmentInfo"
            class="text-xs-center"
          >
            {{ this.getConfigItem("APPOINTMENT_CHECKEDIN_TEXT") }}
          </h2>
          <h2
            v-if="isShowCheckinHeader && !isShowAppointmentInfo"
            class="text-xs-center"
          >
            {{ this.getConfigItem("CHECKIN_TEXT") }}
          </h2>
          <br v-if="isShowCheckinHeader" />
        </template>
        <template v-if="isShowExistingTicket">
          <h2 class="text-xs-center">
            {{ this.getConfigItem("EXISTING_TICKET1_TEXT") }}
          </h2>
        </template>
        <div style="text-align: center">
          <span
            v-if="this.getConfigItem('USE_CLASSIFICATIONS', true)"
            style="display: inline-block"
          >
            <span
              v-if="!this.getConfigItem('HIDE_LOCATION_SERVICE_TITLE', true)"
            >
              {{ this.getConfigItem("TCKT_LOCATION_TEXT") }}</span
            >
            <span
              v-if="!this.getConfigItem('HIDE_LOCATION_SERVICE_TITLE', true)"
              :class="this.getConfigItem('SERVICE_TEXT_NUMBER_STYLE')"
            >
              <b> {{ location }}</b></span
            >
            <br />
            <span
              v-if="!this.getConfigItem('HIDE_LOCATION_SERVICE_TITLE', true)"
            >
              {{ this.getConfigItem("TCKT_SERVICE_TEXT") }}</span
            >
            <span :class="this.getConfigItem('SERVICE_TEXT_NUMBER_STYLE')"
              ><b>
                {{ classificationName ? classificationName : serviceName }}
                <template
                  v-if="this.getConfigItem('HIDE_LOCATION_SERVICE_TITLE', true)"
                  >service</template
                >
              </b>
            </span>
          </span>
          <span v-else style="display: inline-block; text-align: left">
            {{ this.getConfigItem("TCKT_LOCATION_TEXT") }}
            <b>{{ location }}</b>
            <br />
            {{ this.getConfigItem("TCKT_SERVICE_TEXT") }}
            <b>{{ serviceName }}</b>
          </span>
          <br />
          <h2 class="text-xs-center">
            <span :class="this.getConfigItem('TICKET_TEXT_NUMBER_STYLE')">
              {{ this.getConfigItem("TICKET_TEXT") }}
              <span
                :style="{
                  color: this.getConfigItem('HIGHLIGHTED_COLOUR_TEXT'),
                }"
                class="ticket-text-ticketnumber-style"
              >
                {{ ticketNumber }}
              </span>
            </span>
          </h2>
          <!-- show wait count -->
          <div v-if="this.getConfigItem('SHOW_WAIT_COUNT_INFO', true)">
            <br />
            <h3
              v-if="this.getConfigItem('TICKET_SHOW_POSITION', true)"
              class="text-xs-center ticket-position-text-style"
              :style="{ color: this.getConfigItem('WARNING_COLOUR') }"
            >
              {{ this.getConfigItem("CURRENT_POSITION1_TEXT") }}
              <span
                :style="{
                  color: this.getConfigItem('HIGHLIGHTED_COLOUR_TEXT'),
                }"
              >
                {{ queuePosition }}<sup>{{ ordinalNumber }}</sup>
              </span>
              {{ this.getConfigItem("CURRENT_POSITION2_TEXT") }}
            </h3>
          </div>
        </div>
        <!-- show wait times -->
        <div v-if="this.getConfigItem('SHOW_WAIT_TIMES_INFO')">
          <h3
            v-if="
              this.getConfigItem('SHOW_WAIT_TIMES_INFO', true) &&
              this.getConfigItem('TICKET_SHOW_WAIT_TIME', true)
            "
            class="text-xs-center ticket-wait-text-style"
          >
            {{ this.getConfigItem("WAIT_TIME_TEXT") }}
            <b>
              <span
                :style="{
                  color: this.getConfigItem('HIGHLIGHTED_COLOUR_TEXT'),
                }"
              >
                {{ waitTimeEst | getShortFormattedWaitTime }}
              </span>
            </b>
          </h3>
          <br />
          <h3 class="text-xs-center font-weight-normal wait-info-text-style">
            <template v-if="!isShowExistingTicket">{{
              this.getConfigItem("WAIT_TEXT")
            }}</template>
            <template v-if="isShowExistingTicket">
              {{ this.getConfigItem("EXISTING_TICKET2_TEXT") }}
            </template>

            <br />
            {{ this.getConfigItem("CONSTANT_UPDATE_TEXT") }}
          </h3>
        </div>
        <!-- wait screen urls -->
        <div v-if="waitScreenURLs && waitScreenURLs.length > 0">
          <br />
          <div
            v-for="waitScreenURL in waitScreenURLs"
            :key="waitScreenURL.url"
            style="text-align: center"
          >
            <a
              :href="waitScreenURL.url"
              class="waitscreen-url-text"
              target="_blank"
              >{{ waitScreenURL.title }}</a
            >
            <br />
            <br />
          </div>
        </div>
      </div>

      <br />
      <v-row row wrap>
        <v-col xs6 class="text-xs-right">
          <v-btn
            tile
            color="info"
            :style="[
              { color: this.getConfigItem('INFO_COLOUR_TEXT') },
              {
                'background-color': this.getConfigItem('BTN_BACKGROUND_COLOUR'),
              },
            ]"
            @click="$root.backToHome()"
            class="cancel-btn"
            >{{ this.getConfigItem("BTN_HOME_TEXT") }}</v-btn
          >
        </v-col>
        <v-col xs6 class="text-xs-left">
          <v-btn
            tile
            color="warning"
            :style="{ color: this.getConfigItem('WARNING_COLOUR_TEXT') }"
            @click="cancelEnqueue()"
            class="cancel-btn"
            >{{ this.getConfigItem("BTN_CANCEL_TEXT") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import cookieMixin from "@/mixins/cookieMixin";
import { helper } from "@/helper";
import { mapGetters } from "vuex";

export default {
  mixins: [cookieMixin],
  data: function () {
    return {
      waitTimeEst: null,
      caseCookie: null,
      serviceName: null,
      classificationName: null,
      ticketNumber: null,
      queuePosition: null,

      location: null,
      waitScreenURLs: null,

      intervalId: null,
      isShowAppointmentInfo: false,
      isShowCheckinHeader: false,
      random: "hello",
    };
  },
  mounted: function () {
    this.caseCookie = helper.getCaseCookie();
    if (!this.caseCookie) {
      this.$router.push("/");
      return;
    }

    this.checkQueueInfo();

    let userCookie = helper.getUserCookie();
    if (userCookie) {
      this.isShowCheckinHeader = userCookie.isShowCheckinHeader;
    }

    if (process.env.VUE_APP_ISDEBUGGING) {
      console.log("%c settings", "color:red", {
        isShowCheckinHeader: this.isShowCheckinHeader,
        isShowAppointmentInfo: this.isShowAppointmentInfo,
      });
    }

    if (this.caseCookie.IsForAppointment) {
      this.isShowAppointmentInfo = true;
      return;
    }

    try {
      this.waitScreenURLs = JSON.parse(this.getConfigItem("WAITSCREEN_URLS"));
    } catch (error) {}

    this.intervalId = setInterval(() => {
      this.checkQueueInfo();
    }, this.getConfigItem("POLLING_TIME_MS"));
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("existingTicket", false); // clear show existing ticket
    clearInterval(this.intervalId);
    next();
  },
  // beforeDestroy() {
  //   clearInterval(this.intervalId);
  // },
  methods: {
    checkQueueInfo() {
      if (process.env.VUE_APP_ISDEBUGGING) {
        console.log("checkQueueInfo() CaseCookie:", this.caseCookie);
        console.log("checkQueueInfo() CaseId:", this.caseCookie.CaseId);
      }
      axios
        .get("/Cases/" + this.caseCookie.CaseId)
        .then((response) => {
          if (process.env.VUE_APP_ISDEBUGGING) {
            console.log("%c case-response:", "color:green", response);
          }
          if (
            response.data.ServiceDesc != null &&
            response.data.ServiceDesc.length > 0
          ) {
            this.serviceName = response.data.ServiceDesc;
          } else {
            this.serviceName = response.data.ServiceName;
          }
          this.classificationName = this.caseCookie.classificationName;
          this.ticketNumber = response.data.Ticket;
          this.queuePosition = response.data.QueuePosition + 1;
          this.waitTimeEst = response.data.WaitTimeEst;

          var branchName = "";

          if (
            response.data.UnitTypeId == this.getConfigItem("BRANCH_UNITTYPEID")
          ) {
            if (
              response.data.UnitDescription != null &&
              response.data.UnitDescription.length > 0
            ) {
              branchName = response.data.UnitDescription;
            } else {
              branchName = response.data.UnitName;
            }
          } else {
            branchName = response.data.UnitParentName;
          }

          // If its been called to a location (i.e. a Counter Number) use that, otherwise the branchName
          this.location = response.data.LocationName
            ? response.data.LocationName
            : branchName;

          if (response.data.CaseStatus != 0) {
            helper.deleteCaseCookie();
            this.$router.push("/");
          }

          if (response.data.EntityStatus === 6) {
            // console.log("%c Going to EnqueueCall", "color:pink");

            this.$router.push("EnqueueCall");
          }
        })
        .catch(function (error) {
          console.log("checkQueueInfo()", error);
          helper.deleteCaseCookie();
          this.$store.commit(
            "setErrorMessage",
            "Problem with retrieving queue info. Please try again."
          );
          this.$router.push("Error");
          // clearInterval(this.intervalId); // no reference to this
        });
    },
    cancelEnqueue() {
      this.$router.push("CancelEnqueue");
    },
  },
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      // "isShowLoadingMessage",
      // "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    isShowExistingTicket() {
      return this.$store.getters.existingTicket;
    },
    ordinalNumber() {
      var j = this.queuePosition % 10;
      var k = this.queuePosition % 100;
      if (j == 1 && k != 11) {
        return "st";
      }
      if (j == 2 && k != 12) {
        return "nd";
      }
      if (j == 3 && k != 13) {
        return "rd";
      }
      return "th";
    },
  },
  watch: {},
};
</script>
